<template>
  <div id="">
    <el-table
      class="disTable"
      ref="multipleTable"
      height="65vh"
      stripe
      :border="false"
      :header-row-style="{
        background: 'none',
        color: '#647196'
      }"
      :header-cell-style="{
        background: '#F1F4F6',
        color: '#3D4042',
        height: '56px',
        fontSize: '16px',
        padding: '0'
      }"
      :row-style="{
        background: 'none',
        height: '56px',
        borderBottom: '1px solid #D9DCDE'
      }"
      :cell-style="{
        background: 'none',
        color: '#3D4042',
        fontSize: '16px',
        borderBottom: '1px solid #D9DCDE'
      }"
      :data="tableData"
      :row-class-name="tableRowClassName"
      @selection-change="handleSelectionChange"
      @select-all="selectAll"
      row-key="id"
      @header-click="handleHeaderClick"
      @filter-change="handleGlobalFilterChange"
      :filter-multiple="true"
      empty-text="无数据"
    >
      <el-table-column v-if="select" type="selection" width="55">
      </el-table-column>
      <el-table-column
        v-if="isShowIndex"
        label="序号"
        type="index"
        width="55"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in dataList.columns"
        :key="index"
        :align="item.align || 'center'"
        :prop="item.prop"
        :label="item.label"
        :show-overflow-tooltip="item.showToolitip == '1' ? false : true"
        :filters="item.filters || null"
        :filter-method="item.filters ? filterTag : null"
        :filter-placement="item.filters ? 'bottom-end' : null"
        :width="item.width"
        :fixed="item.fixed"
      >
        <template slot-scope="scope">
          <template v-if="item.slot">
            <slot :name="item.slot" :scope="scope"></slot>
          </template>
          <template v-else>
            <span>{{ scope.row[item.prop] }}</span>
          </template>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(actionCol, index) in actionColumns2"
        :key="`action-${index}`"
        :label="actionCol.label"
        width="200px"
        :filters="actionCol.filterOptions || []"
        :filter-method="(value, row) => {
          const prop = actionCol.prop || actionCol.label;
          return row[prop] === value;
        }"
        :column-key="actionCol.label"
        :filterable="true"
      >
        <template slot-scope="scope">
          <span>{{ scope.row[actionCol.prop || actionCol.label] }}</span>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        prop="operation"
        width="150px"
        align="center"
        label="操作">
        <template slot-scope="scope">
          <el-button
            :disabled="scope.row.buttonList && scope.row.buttonList.length && scope.row.buttonList.includes('COMPILE') ? false : true"
            :class="scope.row.buttonList && scope.row.buttonList.length && scope.row.buttonList.includes('COMPILE') ? 'delClass' : ''"
            @click="editRow(scope.row)"
            style="color: #0090ff; font-size: 16px"
            type="text"
            >编辑</el-button
          >
          <el-button
            :disabled="scope.row.buttonList && scope.row.buttonList.length && scope.row.buttonList.includes('DELETE') && !!scope.row.userId ? false : true"
            :class="scope.row.buttonList && scope.row.buttonList.length && scope.row.buttonList.includes('DELETE') && !!scope.row.userId ? 'delClass' : ''"
            @click="delRow(scope.row)"
            style="color: #eb3538; font-size: 16px"
            type="text"
            >清空</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="block" v-if="isShowPagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total,prev, pager, next,sizes,jumper"
        :total="Number(page.total)"
        background
        :page-size="page.size"
        :current-page.sync="page.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :style="{ textAlign: 'right' }"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {
  userTagpage
} from "@/api/base.js";
export default {
  props: {
    actionColumns: {
      type: Array,
      default: () => {
        return [];
      }
    },
    page: {
      type: Object,
      default: () => {
        return {
          total: 0,
          size: 10,
          page: 1
        };
      }
    },
    dataList: {
      type: Object,
      default: () => {
        return {
          tableData: [],
          columns: []
        };
      }
    },
    selectedIdOptions: {
      type: Array,
      default: () => {
        return [];
      }
    },
    checkListOptions: {
      type: Array,
      default: () => {
        return [];
      }
    },
    isShowIndex: {
      type: Boolean,
      default: true
    },
    isShowPagination: {
      type: Boolean,
      default: true
    },
    maxHeight: {
      type: Number,
      default: 500
    },
    select: {
      type: Boolean,
      default: false
    },
    delSelected: {
      type: Object,
      default: () => {
        return {};
      }
    },
    tableData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 新增：接收父组件传递的持久化筛选状态
    persistFilterState: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tagList: [],
      actionColumns2: [],
      loadingMap: {},
      // 核心：初始化时从父组件读取筛选状态
      allFilterValues: { ...this.persistFilterState }
    };
  },
  mounted() {
    console.log("组件mounted，初始dataList：", this.tableData);
    // 初始化表格数据，避免首次空白
    this.$nextTick(() => {
      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.data = this.tableData;
        // 新增：组件挂载时恢复筛选状态（修正调用方式）
        this.restoreFilterState();
      }
    });
  },
  watch: {
    dataList: {
      handler(val) {
        if (!this.selectedIdOptions.length) return;
        this.updateSelectedItemsOnPageChange();
      },
      deep: true,
      immediate: true
    },
    delSelected: {
      handler(val) {
        if (!val || !Object.keys(val).length) return;
        this.$nextTick(() => {
          this.$refs.multipleTable.toggleRowSelection(val, false);
        });
      },
      deep: true
    },
    checkListOptions: {
      handler(val) {
        // console.log(val, "val");
        this.$nextTick(() => {
          val.forEach(element => {
            this.$refs.multipleTable.toggleRowSelection(element, false);
          });
        });
      },
      deep: true
    },
    actionColumns: {
      handler(val) {
        // 无论是否为空数组，都要更新 actionColumns2
        this.actionColumns2 = (val || []).map(item => ({
          ...item,
          filterOptions: item.filterOptions || []
        }));
      },
      immediate: true,
      deep: true
    },
    // 新增：监听父组件筛选状态变化，同步并恢复
    persistFilterState: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.allFilterValues = { ...newVal };
        this.$nextTick(() => {
          this.restoreFilterState();
        });
      }
    },
    // 新增：监听tableData变化，确保数据更新后筛选状态仍保留
    tableData: {
      deep: true,
      immediate: true,
      handler() {
        this.$nextTick(() => {
          if (this.$refs.multipleTable) {
            this.restoreFilterState();
          }
        });
      }
    }
  },
  methods: {
    // 新增：修复筛选状态恢复方法（兼容所有Element UI版本）
    restoreFilterState() {
      if (!this.$refs.multipleTable || !Object.keys(this.allFilterValues).length) return;

      // const table = this.$refs.multipleTable;
      // // 遍历所有筛选列，手动恢复选中状态（Element UI 正确调用方式）
      // Object.keys(this.allFilterValues).forEach(columnKey => {
      //   const values = this.allFilterValues[columnKey];
      //   try {
      //     // 方式1：兼容新版Element UI
      //     if (table.doFilter) {
      //       table.doFilter(values, columnKey);
      //     } 
      //     // 方式2：兼容旧版Element UI
      //     else if (table.filter) {
      //       table.filter(values, columnKey);
      //     }
      //     // 方式3：兜底 - 直接操作列的筛选值（最稳定）
      //     else {
      //       const column = table.columns.find(col => col.columnKey === columnKey);
      //       if (column) {
      //         column.filteredValue = values;
      //         table.store.commit('filterChange', {
      //           column,
      //           values
      //         });
      //         table.store.updateCurrentPage();
      //       }
      //     }
      //   } catch (e) {
      //     console.warn(`恢复【${columnKey}】筛选状态失败：`, e);
      //   }
      // });
    },
    async handleHeaderClick(column, event) {
      // console.log("表头点击事件触发：", column, event);
      if (!column || !column.label) return;

      const actionCol = this.actionColumns2.find(
        col => col.label === column.label || col.prop === column.label
      );
      if (!actionCol) {
        // console.log("未匹配到actionColumns2列：", column.label);
        return;
      }

      const target = event.target;
      const isFilterIcon = 
        target.classList.contains('el-icon-filter') || 
        target.parentElement.classList.contains('el-table-column-filter') ||
        target.closest('.el-table-column-filter-trigger');
      
      // console.log(`是否点击筛选图标：${isFilterIcon}，列：${actionCol.label}`);
      
      if (isFilterIcon || actionCol.label) {
        const label = actionCol.label;
        if (this.loadingMap[label]) return;
        this.loadingMap[label] = true;

        try {
          await this.loadFilterOptions(label);
          this.$nextTick(() => {
            const filterTrigger = document.querySelector(
              `.el-table__header th[column-key="${label}"] .el-table-column-filter-trigger`
            );
            if (filterTrigger) {
              filterTrigger.click();
            }
          });
        } catch (err) {
          console.error(`加载【${label}】筛选选项失败：`, err);
        } finally {
          this.loadingMap[label] = false;
        }
      }
    },
    async loadFilterOptions(label) {
      try {
        // console.log(`调用接口获取【${label}】的筛选选项`);
        let params = {
          tagName: '',
          tagType: label,
          page: 1,
          size: 999,
        };
        const res = await userTagpage(params);
        if (res.data.code == 200) {
          this.tagList = res.data.data.records || [];
        }
        const options = this.tagList.map(item => ({ text: item.tagName, value: item.id }));
        
        const col = this.actionColumns2.find(c => c.label === label);
        if (col) {
          col.filterOptions = options;
          // console.log(`【${label}】筛选选项加载完成：`, options);
          this.$forceUpdate();
        }
      } catch (err) {
        console.error(`加载【${label}】筛选选项失败:`, err);
      }
    },
    // 核心修复：保留所有列的筛选值，仅更新当前操作列
    handleGlobalFilterChange(filters) {
      // console.log("全局筛选事件触发，原始参数：", filters);
      
      // 1. 遍历所有筛选参数（仅更新当前操作的列，保留其他列的旧值）
      Object.keys(filters).forEach(columnKey => {
        const actionCol = this.actionColumns2.find(col => col.label === columnKey);
        if (actionCol) {
          if (filters[columnKey] && filters[columnKey].length > 0) {
            // 当前列有选中值：更新/新增该列的筛选值
            this.allFilterValues[columnKey] = [...filters[columnKey]];
          } else {
            // 当前列无选中值：删除该列的筛选值（取消筛选）
            delete this.allFilterValues[columnKey];
          }
        }
      });

      // 2. 转换为数组格式供父组件使用
      const filterArr = Object.keys(this.allFilterValues).map(column => ({
        column: column,
        values: [...this.allFilterValues[column]]
      }));

      // 3. emit 所有列的筛选值合集
      // console.log("最终emit的所有筛选值：", filterArr);
      this.$emit("filterValuesChange", filterArr);
    },
    editRow (row) {
      this.$emit("editRow", row);
    },
    delRow (row) {
      this.$emit("delRow", row);
    },
    filterTag(value, row) {
      return row.primaryPollutant === value;
    },
    handleCurrentChange(data) {
      this.$emit("handleCurrentChange", data);
    },
    handleSizeChange(data) {
      this.$emit("handleSizeChange", data);
    },
    handleSelectionChange(data) {
      this.$emit("handleSelectionChange", data);
    },
    selectAll(data) {
      this.$emit("selectAll", data);
    },
    updateSelectedItemsOnPageChange() {
      if (!this.tableData) return;
      const selectedCurrentPageItems = this.tableData.filter(item =>
        this.selectedIdOptions.includes(item.id)
      );
      // console.log(selectedCurrentPageItems, 1111111);
      this.$refs.multipleTable.clearSelection();
      selectedCurrentPageItems.forEach(item =>
        this.$nextTick(() => {
          this.$refs.multipleTable.toggleRowSelection(item, true);
        })
      );
    },
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? "odd-row" : "even-row";
    }
  }
};
</script>

<style scoped lang="less">
/deep/.el-table {
  background: none;
}

.block {
  width: calc(100% - 80px);
}

/deep/.el-table::before {
  display: none;
}

/deep/.el-table .el-table__cell,
/deep/.el-table td,
/deep/.el-table th {
  padding: 0;
}
/deep/.el-table .el-table__cell {
  background: #fff !important;
}
/deep/.el-table th.el-table__cell {
  background: rgb(241, 244, 246) !important;
  cursor: pointer !important;
}
/deep/.el-table__header th:hover,
/deep/.el-table__header th:hover * {
  cursor: pointer !important;
}
/deep/.el-table .even-row,
/deep/.el-table tr:hover,
/deep/.el-table .el-table__body tr.el-table__row:hover,
/deep/.el-table--enable-row-hover .el-table__body tr.even-row:hover > td {
  background: none !important;
}

/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li {
  background: none;
  border-radius: 4px;
  border: 1px solid #dddfe8;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #272a31;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: none;
  border-radius: 4px;
  border: 1px solid #3666ea;
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 16px;
  color: #3666ea;
}

/deep/.el-pagination span:not([class*="suffix"]) {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 16px;
  color: #272a31;
}

/deep/.el-table {
  .el-table__body-wrapper::-webkit-scrollbar {
    display: block !important;
  }
}

/deep/.el-table__fixed-body-wrapper .el-table__body {
  padding-bottom: 4px !important;
}

.editClass {
  color: #0090ff;
  font-size: 16px;
}
.delClass {
  color: #eb3538;
  font-size: 16px;
}

/deep/ .el-table-column-filter-trigger {
  display: inline-block !important;
  cursor: pointer !important;
}
/deep/.el-table-column-filter {
  display: inline-block !important;
}
/deep/.el-table {
  // 无数据提示容器样式
  .el-table__empty-block {
    position: relative;
    height: 100% !important; // 占满表格内容区高度
    min-height: calc(65vh - 56px) !important; // 表格总高度 - 表头高度（56px）
    display: flex;
    align-items: center; // 垂直居中
    justify-content: center; // 水平居中
    padding: 0 !important;
    margin: 0 !important;
  }

  // 无数据文字样式（可选自定义）
  .el-table__empty-text {
    font-size: 16px !important; // 与表格文字大小一致
    color: #3D4042 !important; // 与表格文字颜色一致
    line-height: 1.5;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/personLabel/components/table.vue